import controller from './query-rule-value.controller';
import template from './query-rule-value.html';
import './query-rule-value.scss';

export default {
	controller,
	template,
	bindings: {
		options:  '<?',
		rule:     '<rule',
		field:    '<field',
		change:   '&?ngChange',
		required: '<?ngRequired',
		value:    '=ngModel',
	},
	require:  {
		ngModelCtrl: '?ngModel',
		children:    '^^?queryBuilderChildren',
	},
};
